<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item>
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.value"
        placeholder="字典类别/字典名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import { SYSPARAM_STATUS } from "../../utils/constants";
import butn from "@/components/button/index";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      size: "small",
      filters: undefined,
      options: [],
      statusOptions: SYSPARAM_STATUS,
    };
  },
  created() {
    const emptyObj = Object.create(null);
    this.filters = emptyObj;
  },
  methods: {
    initData() {
      //查询
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
